import { HttpErrorResponse } from "@angular/common/http";

import { User } from "@core/models/user.model";
import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromAuth from "./auth.reducer";
import { AuthState, MfaStage } from "./auth.reducer";

export const SELECT_AUTH_STATE = createFeatureSelector<fromAuth.AuthState>(
  fromAuth.AUTH_FEATURE_KEY
);

export const SELECT_LOGGED_IN_USER = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): User | undefined => state.user
);

export const SELECT_LOGIN_ERROR = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): HttpErrorResponse | null => state.loginError
);

export const SELECT_AUTH_LOADING = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): boolean => state.loading
);

/** True while a two-factor flow is pending, i.e. a two-factor screen should be shown. */
export const SELECT_MFA_PENDING = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): boolean => state.mfaToken !== null
);

/** Which two-factor screen to show (loading / challenge / enroll / recovery-display). */
export const SELECT_MFA_STAGE = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): MfaStage => state.mfaStage
);

export const SELECT_MFA_TOKEN = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): string | null => state.mfaToken
);

export const SELECT_MFA_TARGET = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): string | null => state.mfaTarget
);

export const SELECT_MFA_SHARED_KEY = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): string | null => state.mfaSharedKey
);

export const SELECT_MFA_AUTHENTICATOR_URI = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): string | null => state.mfaAuthenticatorUri
);

export const SELECT_MFA_RECOVERY_CODES = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): string[] => state.mfaRecoveryCodes
);

export const SELECT_MFA_ERROR = createSelector(
  SELECT_AUTH_STATE,
  (state: AuthState): HttpErrorResponse | null => state.mfaError
);
